import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
var modal_actions_suffix = Math.random().toString(36).substring(7);
export var SHOW_MODAL = "SHOW_MODAL:".concat(modal_actions_suffix);
export var MODAL_CONFIRM = "MODAL_CONFIRM:".concat(modal_actions_suffix);
export var MODAL_CANCEL = "MODAL_CANCEL:".concat(modal_actions_suffix);
export var HIDE_MODAL = "HIDE_MODAL:".concat(modal_actions_suffix);